/*
  Кнопка «Снять запись» о банкротстве с подтверждением.

  Аудит 28.10.2026, раздел 5.3: запись снималась с одного нажатия, и счёт сразу
  возвращался в подачу. Если нажали по ошибке, документы по счёту собираются
  снова, а запись о процедуре внесена человеком и сама не вернётся. Поэтому
  сначала вопрос, и в нём сказано, что произойдёт со счётом.

  Вынесено из `AccountBankruptcy.jsx`: файл у предела в триста строк. Запрос и
  его ошибка живут в окне (правило кабинета: ошибка видна там, где нажали).
*/

import { useState } from 'react'

import { api } from '../api/client.js'
import { Confirm } from './Common.jsx'

export default function BankruptcyRemove({ procedure, onDone }) {
  const [asking, setAsking] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState(null)

  const close = () => {
    setAsking(false)
    setError(null)
  }

  const remove = async () => {
    setBusy(true)
    setError(null)
    try {
      await api.removeBankruptcy(procedure.id)
      setAsking(false)
      onDone('Запись о банкротстве снята, счёт возвращён в работу.')
    } catch (failure) {
      setError(failure)
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <button type="button" className="button button--quiet" onClick={() => setAsking(true)}>
        Снять запись
      </button>
      {asking ? (
        <Confirm
          title="Снять запись о банкротстве"
          action="Снять запись"
          onConfirm={remove}
          onCancel={close}
          busy={busy}
          error={error}
        >
          <p>{procedure.explanation}</p>
          <p>
            Запись будет снята, а счёт сразу вернётся в подачу: по нему снова можно собирать
            документы. Если процедура была внесена верно, оставьте запись.
          </p>
        </Confirm>
      ) : null}
    </>
  )
}
